import PageWrapper from '@/shared/components/PageWrapper/PageWrapper';
import styles from './Imprint.module.css';
import { Trans, useTranslation, withTranslation } from 'react-i18next';
import { IonRouterLink } from '@ionic/react';
import contactInformation from '@/shared/config/contactInformation';
import env from '@beam-australia/react-env';

const Imprint: React.FC = () => {
  const { t } = useTranslation();

  const homepageUrl = env('HOSTNAME')?.split('//')[1];

  return (
    <PageWrapper name="imprint-page" showFooter={true} className={styles.page}>
      <h1>{t('imprint.title')}</h1>
      <p>
        {homepageUrl} {t('imprint.is_a_offer')}
      </p>

      <h2>{t('imprint.provider.title')}</h2>
      <p>
        {t('imprint.provider.p1')} <br /> {t('imprint.provider.p2')} <br /> {t('imprint.provider.p3')}
      </p>

      <h2>{t('imprint.representative.title')}</h2>
      <p>{t('imprint.representative.p1')}</p>

      <h2>{t('imprint.contact.title')}</h2>
      <p>
        {t('imprint.contact.telephone')} <br />
        <Trans
          i18nKey="imprint.contact.email"
          values={{ emailAddress: contactInformation.contact.title }}
          components={{
            email: <IonRouterLink href={contactInformation.contact.url} target="_blank" rel="noopener noreferrer" />
          }}
        />
      </p>

      <h2>{t('imprint.register_court.title')}</h2>
      <p>{t('imprint.register_court.p1')}</p>

      <h2>{t('imprint.tax_identification_number.title')}</h2>
      <p>{t('imprint.tax_identification_number.p1')}</p>

      <h2>{t('imprint.responsible.title')}</h2>
      <p>
        {t('imprint.responsible.p1')} <br /> {t('imprint.responsible.p2')} <br />
        {t('imprint.responsible.p3')} <br /> {t('imprint.responsible.p4')}
      </p>
    </PageWrapper>
  );
};

export default withTranslation()(Imprint);
